export const appType = () => {
    return process.env.REACT_APP_APP_TYPE;
};

export const env = () => {
    return process.env.REACT_APP_ENV || 'dev';
};